import {
	REGISTRATION_ERROR, REGISTRATION_SUCCESS,TEST,DEFAULT_ROLE,AUTHENTICATION_INITIAL_STATE,AUTHENTICATION_SUCCESS,AUTHENTICATION_PENDING,AUTHENTICATION_ERROR,UPDATE_USERS,UPDATE_USERS_ERROR
} from '../actions/ActionTypes';

const initialState = {
    isLoginSuccess : false,
	isLoginPending: false,
	isLoginError: false,
	loginError: null,
	isRigisterSuccess: false,
	isRigisterPending: false,
	isRigisterError: false,
	isLogged: false,
	user: {},
	defaultRole: null,
	registerSuccess: {},
	registerError: {}
};
export default function (state = initialState, action) {
	switch (action.type) {
		case TEST:
			return {
				...state,
	           isLoginSuccess: action.data,				
			};

			case AUTHENTICATION_INITIAL_STATE:
			return {
				...state,
				isLoginSuccess : false,
				isLoginPending: false,
				isLoginError: false,
				loginError: null,
				isRigisterSuccess: false,
				isRigisterPending: false,
				isRigisterError: false,
				isLogged: false,
				user: {},
				defaultRole: null,
			};
		case AUTHENTICATION_SUCCESS:
			return {
				...state,
				isLoginSuccess: false,
				isLoginPending: false,
				isLoginError: false,
				loginError: false,
				isRigisterSuccess: false,
				isRigisterPending: false,
				isRigisterError: false,
				isLogged: false,
				user: action.data
			};
		case AUTHENTICATION_PENDING:
			return {
				...state,
				isLoginSuccess: false,
				isLoginPending: true,
				isLoginError: false,
				loginError: false,
				isRigisterSuccess: false,
				isRigisterPending: false,
				isRigisterError: false,
				isLogged: false,
				user: {}
			};
		case AUTHENTICATION_ERROR:
			return {
				...state,
				isLoginSuccess: false,
				isLoginPending: false,
				isLoginError: true,
				loginError: action.data,
				isRigisterSuccess: false,
				isRigisterPending: false,
				isRigisterError: false,
				isLogged: false,
				user: {},
				roles: []
			};
			case REGISTRATION_SUCCESS:
			return {
				...state,
				registerSuccess: action.data,				
			};
			case REGISTRATION_ERROR:
			return {
				...state,
				registerError: action.data,				
			};
			
			case UPDATE_USERS:
			return {
				...state,
				user: action.data,				
			};
			
			case UPDATE_USERS_ERROR:
			return {
				...state,
				user: action.data,				
			};
			

		case DEFAULT_ROLE:
		return {
			...state,
			defaultRole: action.data,				
		};
		
		default:
			return state;
	}
}